(function () {
  'use strict';

  const MIME_LIMITS = {
    'image/jpeg': 10000000,
    'image/png': 10000000,
    'image/gif': 10000000,
    'video/mp4': 50000000,
    'video/quicktime': 50000000
  };
  const TEXT_LIMITS = { nickname: 80, title: 200, body: 5000 };
  const IMAGE_ACCEPT = 'image/jpeg,image/png,image/gif';

  // DOM に依存せず、Worker と同じ申告値の条件で検証する。
  function attachmentError(items) {
    if (!Array.isArray(items) || items.length > 3) {
      return '写真と動画は合計3点まで添付できます。';
    }
    let videos = 0;
    for (const item of items) {
      if (!item || !Object.hasOwn(MIME_LIMITS, item.mime)) {
        return '画像はJPEG・PNG・GIF、動画はMP4・MOV形式を選んでください。';
      }
      if (item.mime.startsWith('video/'))
        videos++;
      if (
        !Number.isSafeInteger(item.bytes) ||
        item.bytes <= 0 ||
        item.bytes > MIME_LIMITS[item.mime]
      ) {
        return '空のファイルは添付できません。' +
          '画像は1点10MB、動画は1点50MBまでです。';
      }
    }
    return videos > 1 ? '動画は1点まで添付できます。' : '';
  }

  function reviewError(data) {
    if (!Number.isInteger(data.rating) || data.rating < 1 || data.rating > 5) {
      return '満足度を選んでください。';
    }
    const labels = { nickname: 'ニックネーム', title: 'タイトル', body: '本文' };
    for (const [key, max] of Object.entries(TEXT_LIMITS)) {
      if (typeof data[key] !== 'string' || !data[key].trim() || data[key].trim().length > max) {
        return `${labels[key]}は前後の空白を除いて1〜${
          max
        }文字で入力してください。`;
      }
    }
    return '';
  }

  // 同じ session は完了済みアップロードを再利用する。
  // 期限は API 開始時刻から保守的に計る。
  async function submitReview(
    data, files, state, request = fetch, now = Date.now, onProgress
  ) {
    async function post(path, body) {
      const response = await request('/apps/features/review/v2/' + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (!response.ok || result.error) {
        const error = new Error(
          response.status === 401
            ? 'ログイン状態を確認して、もう一度お試しください。'
            : '送信できませんでした。入力内容を確認し、' +
              'もう一度お試しください。'
        );
        error.expired = /Ticket expired or invalid expiry/.test(result.error || '');
        throw error;
      }
      return result;
    }
    try {
      if (state.session && now() >= state.session.expiresAt)
        state.session = null;
      if (!state.session) {
        const started = now();
        const result = await post('uploads', {
          product_id: data.product_id,
          attachments: files.map((file) => ({ mime: file.type, bytes: file.size }))
        });
        if (
          !result.submission_id ||
          !Array.isArray(result.uploads) ||
          result.uploads.length !== files.length ||
          result.uploads.some((upload, index) =>
            upload.slot !== index ||
            !upload.ticket ||
            !upload.target?.url ||
            !Array.isArray(upload.target.parameters)
          )
        ) {
          throw new Error(
            'アップロード先を取得できませんでした。' +
            'もう一度お試しください。'
          );
        }
        state.session = { ...result, expiresAt: started + 3600000, uploaded: new Set() };
      }
      const session = state.session;
      for (const upload of session.uploads) {
        if (session.uploaded.has(upload.slot))
          continue;
        const body = new FormData();
        for (const parameter of upload.target.parameters)
          body.append(parameter.name, parameter.value);
        body.append('file', files[upload.slot]);
        onProgress?.({ phase: 'upload', done: upload.slot + 1, total: files.length });
        const response = await request(upload.target.url, { method: 'POST', body });
        if (!response.ok)
          throw new Error(
            '添付をアップロードできませんでした。' +
            'もう一度お試しください。'
          );
        session.uploaded.add(upload.slot);
      }
      onProgress?.({ phase: 'submit' });
      const result = await post('reviews', {
        ...data,
        submission_id: session.submission_id,
        tickets: session.uploads.map((upload) => upload.ticket)
      });
      if (!result.success)
        throw new Error(
          '送信結果を確認できませんでした。' +
          'もう一度お試しください。'
        );
      return result;
    } catch (error) {
      if (error.expired)
        state.session = null;
      throw error;
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { attachmentError, reviewError, submitReview };
  }
  if (typeof document === 'undefined')
    return;

  function init(root) {
    const form = root.querySelector('[data-review-form]');
    if (!form || form.dataset.ready)
      return;
    form.dataset.ready = 'true';
    const slots = [...form.querySelectorAll('[data-slot]')];
    const files = Array(3).fill(null);
    const urls = Array(3).fill(null);
    const state = { session: null };
    const submit = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-error]');
    const attachmentMessage = form.querySelector('[data-attachment-error]');
    const status = form.querySelector('[data-status]');
    let busy = false;
    function message(node, text) {
      node.textContent = text;
      node.hidden = !text;
    }
    function data() {
      const value = {};
      for (const key of [
        'product_id',
        'customer_name',
        'customer_email',
        'nickname',
        'title',
        'body'
      ]) {
        value[key] = form.elements.namedItem(key).value;
      }
      value.rating = Number(form.elements.namedItem('rating').value);
      for (const key of Object.keys(TEXT_LIMITS))
        value[key] = value[key].trim();
      return value;
    }
    function refresh() {
      const value = data();
      submit.disabled = busy || Boolean(reviewError(value));
      slots.forEach((slot, index) => {
        slot.querySelector('[data-file]').accept = files.some((file) =>
          file?.type.startsWith('video/')
        )
          ? IMAGE_ACCEPT
          : IMAGE_ACCEPT + ',video/mp4,video/quicktime';
        slot.querySelector('[data-choose]').disabled = busy || Boolean(files[index]);
        slot.querySelector('[data-remove]').disabled = busy;
        slot.querySelector('[data-file]').disabled = busy;
      });
      form.querySelectorAll('[name="rating"]').forEach((radio) => {
        radio.closest('label').classList.toggle('is-selected', Number(radio.value) <= value.rating);
      });
    }
    function setFile(index, file) {
      if (urls[index])
        URL.revokeObjectURL(urls[index]);
      urls[index] = null;
      files[index] = file;
      state.session = null;
      const slot = slots[index];
      const preview = slot.querySelector('[data-preview]');
      preview.replaceChildren();
      preview.hidden = !file;
      slot.querySelector('[data-choose]').hidden = Boolean(file);
      slot.querySelector('[data-remove]').hidden = !file;
      slot.querySelector('[data-play]').hidden = !file?.type.startsWith('video/');
      if (file) {
        const video = file.type.startsWith('video/');
        const media = document.createElement(video ? 'video' : 'img');
        if (video) {
          media.muted = true;
          media.playsInline = true;
          media.preload = 'metadata';
        }
        else
          media.alt = file.name;
        media.setAttribute('aria-label', file.name);
        urls[index] = URL.createObjectURL(file);
        media.src = urls[index];
        preview.append(media);
      }
      message(attachmentMessage, '');
      refresh();
    }
    slots.forEach((slot, index) => {
      const picker = slot.querySelector('[data-file]');
      slot.querySelector('[data-choose]').addEventListener('click', () => {
        if (!busy)
          picker.click();
      });
      slot.querySelector('[data-remove]').addEventListener('click', () => {
        if (busy)
          return;
        setFile(index, null);
        slot.querySelector('[data-choose]').focus();
      });
      picker.addEventListener('change', () => {
        const file = picker.files[0];
        picker.value = '';
        if (!file || busy)
          return;
        const next = files.map((existing, i) => i === index ? file : existing).filter(Boolean);
        const problem = attachmentError(
          next.map((item) => ({ mime: item.type, bytes: item.size }))
        );
        if (problem) {
          message(attachmentMessage, problem);
          return;
        }
        setFile(index, file);
        slot.querySelector('[data-remove]').focus();
      });
    });
    form.addEventListener('input', () => {
      refresh();
      const value = data();
      const tooLong = Object.entries(TEXT_LIMITS).some(([key, max]) => value[key].length > max);
      message(error, tooLong ? reviewError(value) : '');
    });
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy)
        return;
      const value = data();
      const problem = reviewError(value);
      if (problem) {
        message(error, problem);
        return;
      }
      busy = true;
      message(error, '');
      function onProgress(progress) {
        const text = progress.phase === 'upload'
          ? `アップロード中 ${progress.done}/${progress.total}`
          : '送信中';
        status.textContent = text;
        submit.textContent = text;
      }
      onProgress({ phase: 'submit' });
      submit.classList.add('is-submitting');
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('[name="rating"], [name="nickname"], [name="title"], [name="body"]')
        .forEach((input) => {
          input.disabled = true;
        });
      submit.disabled = true;
      slots.forEach((slot) =>
        slot.querySelectorAll('button, input').forEach((input) => {
          input.disabled = true;
        })
      );
      try {
        await submitReview(value, files.filter(Boolean), state, fetch, Date.now, onProgress);
        form.hidden = true;
        const success = root.querySelector('[data-success]');
        success.hidden = false;
        success.focus();
        urls.forEach((url) => {
          if (url)
            URL.revokeObjectURL(url);
        });
      } catch (failure) {
        message(
          error,
          failure.message || '送信できませんでした。もう一度お試しください。'
        );
      } finally {
        busy = false;
        form.querySelectorAll('[name="rating"], [name="nickname"], [name="title"], [name="body"]')
          .forEach((input) => {
            input.disabled = false;
          });
        form.removeAttribute('aria-busy');
        submit.classList.remove('is-submitting');
        submit.textContent = '登録する';
        status.textContent = '';
        refresh();
      }
    });
    root.addEventListener(
      'anok:dispose',
      () => urls.forEach((url) => {
        if (url)
          URL.revokeObjectURL(url);
      }),
      { once: true }
    );
    refresh();
  }
  document.querySelectorAll('[data-review-register]').forEach(init);
  document.addEventListener('shopify:section:load', (event) =>
    event.target.querySelectorAll('[data-review-register]').forEach(init)
  );
  document.addEventListener('shopify:section:unload', (event) =>
    event.target.querySelectorAll('[data-review-register]')
      .forEach((root) => root.dispatchEvent(new Event('anok:dispose')))
  );
})();
